export default __webpack_public_path__ + "static/media/user-db.9e385268.png";